export const extractPostCodeFromAddress = (address: string): string => {
  const cleanedAddress = address.trim().replace('  ', ' ')
  const postCodeRegEx =
    /([Gg][Ii][Rr] 0[Aa]{2})|(([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))(\s?[0-9][A-Za-z]{2})/
  const partialPostCodeRegEx =
    /([Gg][Ii][Rr] 0[Aa]{2})|(([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))(\s?[0-9][A-Za-z]{2})?/g

  let extractedPostcode = cleanedAddress.match(postCodeRegEx)
  if (extractedPostcode) {
    return extractedPostcode[0]
  }
  extractedPostcode = cleanedAddress.match(partialPostCodeRegEx)
  // If using partial extraction use last value as it's most likely to be part of a post code
  return extractedPostcode
    ? extractedPostcode[extractedPostcode.length - 1]
    : ''
}
